import * as moment from 'moment';
import { Injectable } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

var signatures = {
  JVBERi0: "application/pdf",
  R0lGODdh: "image/gif",
  R0lGODlh: "image/gif",
  iVBORw0KGgo: "image/png",
  "/9j/": "image/jpg",
  AAAAFGZ0eXBxdCAg: "video/quicktime"
};

@Injectable({
  providedIn: 'root'
})
export class UtilService {
  today: moment.Moment = moment();

  static instance: UtilService;  // https://stackoverflow.com/questions/41432388/how-to-inject-service-into-class-not-component
  constructor(
    private sanitizer: DomSanitizer
  ) { 
    UtilService.instance = this;
  }

  detectMimeType(b64) {
    for (var s in signatures) {
      if (b64.indexOf(s) === 0) {
        return signatures[s];
      }
    }
  }

  arrayBufferToBase64(buffer: ArrayBuffer): string {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  jsonFriendlyUrlString(url) {
    let processedUrl = url.replace(/\t/g, ' ').replace(/\\|\"/g, '');
    return encodeURIComponent(processedUrl);
  }

  convertHexToLongColor(hexValue: string): number {
    let longColor: number = 0;

    hexValue = hexValue.replace("#", "");

    let red: string = hexValue[0] + hexValue[1];
    let green: string = hexValue[2] + hexValue[3];
    let blue: string = hexValue[4] + hexValue[5];

    hexValue = `${blue}${green}${red}`;
    longColor = parseInt(hexValue, 16);

    return longColor;
  }

  convertLongToHexColor(longColor: number) : string {
    let hexValue = longColor.toString(16);

    while (hexValue.length < 6) {
      hexValue = "0".concat(hexValue.toString());
    }

    let blue = hexValue[0].toString() + hexValue[1].toString();
    let green = hexValue[2].toString() + hexValue[3].toString();
    let red = hexValue[4].toString() + hexValue[5].toString();

    hexValue = "#" + red + green + blue;

    return hexValue;
  }

  // Detects if a given hex color is closer to white or black
  isLightOrDark(hexColor: string) : string {
    var c = hexColor.substring(1);      // strip #
    var rgb = parseInt(c, 16);   // convert rrggbb to decimal
    var r = (rgb >> 16) & 0xff;  // extract red
    var g = (rgb >>  8) & 0xff;  // extract green
    var b = (rgb >>  0) & 0xff;  // extract blue
    
    var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709
    
    if (luma < 128) {
      return "dark";
    } else {
      return "light";
    }
  }

  isToday(postDate: moment.Moment) {
    let isToday: boolean = false;
    let newDate: moment.Moment = moment(postDate);
    if(newDate.startOf('day').isSame(this.today.startOf('day'))) {
      isToday = true;
    }
    return isToday;
  }

  sanitizeURL(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url + '#t=0.001');
  }

  parseHTML(str: string): string {
    return str.replace( /(<([^>]+)>)/ig, '');
  }

  blobToBase64(blob): Promise<any> {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }

  // convert height (string) to inches (number) ie. '6.01' = 73 or '6.01.25' = 73.25
  heightToInches(heightStr: string): number {
    let total: number = 0;
    if(heightStr) {
      const parts = heightStr.split('.').map(Number);
      const feet = parts[0] || 0;
      const inches = parts[1] || 0;
      const fraction = parts[2] ? parts[2] / 100 : 0;
      total = feet * 12 + inches + fraction;
    }

    return total;
  }
}
